// One list-builder panel, two tabs: "Quick quiz" (becomes "My list (N)" once a list exists) and "All designs".
// Only one tab is visible at a time (anh 11-01: quiz + browser both open felt confusing). Switching tabs never scrolls
// the page unless the panel top is off-screen. In the designs tab, a one-line summary links back to the list.
(function () {
  const T = window.SLQ_TRACK || { listAction() {} };
  const panel = document.getElementById('lp-quiz');
  if (!panel) return;
  const tabs = panel.querySelectorAll('[data-tab]');
  const panes = panel.querySelectorAll('[data-pane]');
  const summary = panel.querySelector('[data-lp-list-summary]');
  const $ = (n) => '$' + n.toFixed(2);
  const n = () => window.SLQ_STATE.slots.length;
  const hasList = () => !!document.querySelector('#slq .slq-res') && n() > 0;

  function show(id, track) {
    tabs.forEach((t) => { const on = t.dataset.tab === id; t.setAttribute('aria-selected', on); t.classList.toggle('is-on', on); });
    panes.forEach((p) => { p.hidden = p.dataset.pane !== id; });
    if (panel.getBoundingClientRect().top < 0) panel.scrollIntoView({ block: 'start' });
    if (track) T.listAction('tab', id);
  }

  function refresh() {
    const quizTab = panel.querySelector('[data-tab="quiz"]');
    quizTab.textContent = hasList() ? `My list (${n()})` : 'Quick quiz';
    if (summary) {
      if (hasList()) {
        const t = window.SLQ_LOGIC.totals(window.SLQ_STATE.slots.map((s) => s.product));
        summary.disabled = false;
        summary.textContent = `My list: ${t.n} piece${t.n > 1 ? 's' : ''} · ${$(t.now)} →`;
      } else { summary.disabled = true; summary.textContent = 'My list is empty. Tap ＋ Add.'; } // always shown → no layout jump on first add
    }
  }

  panel.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tab],[data-lp-list-summary]'); if (!b) return;
    show(b.dataset.tab || 'quiz', true);
  });
  new MutationObserver(refresh).observe(document.getElementById('slq'), { childList: true });
  window.SLQ_TABS = { show };
  refresh();
  // Email deep link: ?open=designs (chip set by the design browser) or ?open=quiz (never ?view=: Shopify template param) → open that tab and bring the panel into view.
  const view = new URLSearchParams(location.search).get('open');
  if (view === 'designs' || view === 'quiz') {
    show(view === 'designs' ? 'browse' : 'quiz');
    T.listAction('deep-link', view);
    requestAnimationFrame(() => panel.scrollIntoView({ block: 'start' })); // scrollIntoView: Horizon kills window.scrollTo
  }
})();
